import React, { useState } from "react";
import { Button, Layout, Menu, theme } from "antd";
import { Link, useLocation } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import "./index.scss";
import AdminNavbar from "./components/AdminNavbar";

const { Header, Sider, Content } = Layout;

const AdminLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(window.innerWidth < 500);
  const { pathname } = useLocation();

  return (
    <Layout style={{ height: "100vh" }}>
      <Sidebar collapsed={collapsed} />
      <Layout>
        {pathname.startsWith("/main/crm") || (
          <AdminNavbar collapsed={collapsed} setCollapsed={setCollapsed} />
        )}{" "}
        <Content
          style={{
            overflow: "auto",
          }}
        >
          <div
            style={{
              minWidth: 280,
              // padding: "clamp(10px,3%,30px)",
            }}
          >
            {children}
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};
export default AdminLayout;
